import React from "react";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { routes } from "utilities/routing/generatedRoutes";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { AppointmentPhase } from "components";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";

const FlightFromTo = ({ flight }: { flight: server.dto.FlightForList }) => {
  const arrivalDateAndTime = flight.segment.arrival.dateTimeLocal === flight.segment.departure.dateTimeLocal
    ? formatTime(flight.segment.arrival.dateTimeLocal)
    : `${formatWrittenDayMonthYear(flight.segment.arrival.dateTimeLocal)} ${formatTime(flight.segment.arrival.dateTimeLocal)}`;

  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {formatWrittenDayMonthYear(flight.segment.departure.dateTimeLocal)}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {flight.segment.departure.airport.name} [{flight.segment.departure.airport.iata}]
      </div>
      <div className="text-sublabel margin-bottom-small">
        {flight.segment.departure.airport.location}
      </div>
    </div>
    <div className="departure-time nowrap info-text-regular">
      {formatTime(flight.segment.departure.dateTimeLocal)}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        {arrivalDateAndTime}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {flight.segment.arrival.airport.name} [{flight.segment.arrival.airport.iata}]
      </div>
      <div className="text-sublabel margin-bottom-small">
        {flight.segment.arrival.airport.location}
      </div>
    </div>
  </div>;
};

export const cardLayout = (onShowChange: () => void): ListTemplateLayout<server.dto.FlightForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <LargeClickableTitle
        uri={routes.flight_Detail(item.flightId).absolute}
        icon={<AppointmentPhase value={item.phase} displayLabel={false} />}
        title={item.segment.description}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <FlightFromTo flight={item} />
      <LinkedShowsList onChange={onShowChange} shows={item.segment.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        {item.artists.map((artist, index) => <React.Fragment key={artist.artistId}>
          <span>{artist.name}</span>
          {item.artists.length - 1 !== index && <span>, </span>}
        </React.Fragment>)}
      </div>
      <div>
        {item.travellers.map((traveller, index) => <React.Fragment key={traveller.contactId}>
          <span className="s1_gray">{traveller.name.fullName}</span>
          {item.travellers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => item.artists.length === 0 && item.travellers.length === 0
  }
});